export default __webpack_public_path__ + "media/images/mailer/yowzacoin-70361905dcdca30f0acfe645fb8d7d73.png";